import Component from 'vue-class-component';
import moduleStore from './store/bankCardList';
import Vue from 'vue';
import PageState from './store/state';
import infiniteScroll from "@/components/infinite-scroll";
import {
    toast,
  } from '@/utils/util'
/**components**/
@Component({
  directives: { infiniteScroll }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class bankCardListPage extends Vue  {
  
  state = new PageState();
  self: Vue = this;
  list = [];
  showCardModal=false;
  currentCardInfo={
    id:''
  };
  active='';
  busy=true;
  searchparam={
    page:1,
    pageSize:4
  }
  bankCardNoPattern=/^\d{16,19}$/;
  userNamePattern=/^.*\S+.*$/;
  idCardPattern=/^\d{17}[\dXx]$/;
  phonePattern=/^\d{11}$/;
  validateParams={//验证结果是否正确
    bankCardNo:true,
    userName:true,
    idCard:true,
    phone:true
  };
  totalPage = null;

  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
    this.getBankCardListFn(false);
  }
  mounted(moduleData: IinjectDatas) {
    document.title = '银行卡管理';
  }
  getBankCardListFn(isLoadMore) {
    if(!isLoadMore){
        this.searchparam.page=1;
    }
    this.$http('getBankCardList',this.searchparam).then(res=>{
        if(isLoadMore){
            this.list = this.list.concat(res.data.results);
            this.busy  = res.data.results.length==0?true:false;
        }else{
            this.list=res.data.results;
            this.busy = false;
            this.totalPage = res.data.total_pages;
        }
    })
    // this.list = [
    //   {
    //     bankCardNo: '623 8743 1234 2345',
    //     bankName: '招商银行',
    //     id: 1,
    //     idCard: '324567234567898765',
    //     phone: '17765434565',
    //     userName: '章三',
    //   },
    //   {
    //     bankCardNo: '623 8743 1234 2345',
    //     bankName: '招商银行',
    //     id: 2,
    //     idCard: '324567234567898765',
    //     phone: '17765434565',
    //     userName: 'lisis',
    //   },
    // ];
  }
  showModal(item){
    if(item){
        this.currentCardInfo={...item};
    }
    //错误提示清空
    // $('.err-msg').hide();
    this.validateParams={
      bankCardNo:true,
      userName:true,
      idCard:true,
      phone:true
    }
    this.showCardModal=true;

  }
  loadMore(){
    if(this.searchparam.page<this.totalPage){
      this.busy = true;
      this.searchparam.page ++;
      this.getBankCardListFn(true);
    }
  }
  changeStatus(type){
    this.active = type;
  }
  check(type){
    if(!this.currentCardInfo[type]||(!this[type+'Pattern'].test(this.currentCardInfo[type]))){
      this.validateParams[type]=false;
      this.active = '';
    }else{
      this.validateParams[type]=true;
    }
  }
  saveCardInfo(){
    //判断对象各属性是否为空
    let validate = true;
    let validateKey = ['bankCardNo','idCard','phone','userName'];
    for(let key of validateKey){
        if(!this.currentCardInfo[key] || !this[key+'Pattern'].test(this.currentCardInfo[key])){
          this.validateParams[key]=false;
          validate = false;
        }else{
          this.validateParams[key]=true;
        }
    }
    if(!validate){
        return;
    }
    let params = {...this.currentCardInfo};
    if(!params.id){
      delete params.id
    }
    this.$http('saveBankCard',{body:JSON.stringify(params)}).then((res)=>{
        if(res.code==200){
            this.showCardModal=false;
            this.currentCardInfo={id:''};
            toast("保存成功！",'top');
            this.getBankCardListFn(false);
        }else{
            toast(res.message||'新增失败，请稍后再试', 'top')
        }
    });
  }
  delBankCardFn(){
    let vm = this;
    this.$http('delBankCard',{id:this.currentCardInfo.id}).then(res=>{
        if(res.code==200){
            vm.showCardModal=false;
            toast("删除成功！",'top');
            vm.getBankCardListFn(false);
        }else{
            toast(res.message||'删除失败，请稍后再试', 'top')
        }
    })
  }
  addBankCard(){ 
    this.currentCardInfo={
        id:''
    };
    this.showCardModal = true;
    this.validateParams={
      bankCardNo:true,
      userName:true,
      idCard:true,
      phone:true
    }
   }
}
